require("core-js/modules/esnext.global-this.js");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("react"), require("embla-carousel")) : "function" == typeof define && define.amd ? define(["react", "embla-carousel"], t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).EmblaCarouselReact = t(e.React, e.EmblaCarousel);
}(this, function (e, t) {
  "use strict";

  function n(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  var r = n(t);

  function u(e) {
    return e.concat().sort(function (e, t) {
      return e.name > t.name ? 1 : -1;
    }).map(function (e) {
      return e.options;
    });
  }

  function o(t, n) {
    void 0 === t && (t = {}), void 0 === n && (n = []);
    var f = e.useRef(r.default.optionsHandler()),
        a = e.useRef(t),
        i = e.useRef(n),
        c = e.useState(),
        l = c[0],
        d = c[1],
        s = e.useState(),
        p = s[0],
        m = s[1],
        b = e.useCallback(function () {
      l && l.reInit(a.current, i.current);
    }, [l]);
    return e.useEffect(function () {
      if ("undefined" != typeof window && window.document && window.document.createElement && p) {
        r.default.globalOptions = o.globalOptions;
        var e = r.default(p, a.current, i.current);
        return d(e), function () {
          return e.destroy();
        };
      }

      d(void 0);
    }, [p, d]), e.useEffect(function () {
      f.current.areEqual(a.current, t) || (a.current = t, b());
    }, [t, b]), e.useEffect(function () {
      (function (e, t) {
        if (e.length !== t.length) return !1;
        var n = r.default.optionsHandler().areEqual,
            o = u(e),
            f = u(t);
        return o.every(function (e, t) {
          var r = f[t];
          return n(e, r);
        });
      })(i.current, n) || (i.current = n, b());
    }, [n, b]), [m, l];
  }

  return o.globalOptions = void 0, o;
});